import React from "react";
import { Helmet } from "react-helmet";

const ContactUs = () => {
  return (
    <div className="page-container">
      <Helmet>
        <title>Contact Us | AAMSchool</title>
        <link rel="canonical" href="https://www.aamschool.in/contact-us" />
        <meta
          name="description"
          content="Contact AAMSchool for corrections, feedback, suggestions, or business inquiries related to jobs, exams, results, and site content."
        />
        <meta property="og:title" content="Contact Us | AAMSchool" />
        <meta
          property="og:description"
          content="Contact AAMSchool for corrections, feedback, suggestions, or business inquiries related to jobs, exams, results, and site content."
        />
        <meta property="og:url" content="https://www.aamschool.in/contact-us" />
        <meta property="og:type" content="website" />
      </Helmet>
      <h1>Contact Us</h1>
      <p className="page-lead">
        If you have questions, corrections, feedback, or business-related inquiries, you can reach
        us through the contact details below.
      </p>

      <p>
        We welcome messages related to incorrect information, broken links, content suggestions,
        partnership discussions, and general site feedback. Clear feedback helps us improve the site
        for students and job seekers who rely on timely updates.
      </p>

      <section className="page-policy-section">
        <h2>Contact Details</h2>
        <p>
          Email: <a href="mailto:replyto.aamschool@gmail.com">replyto.aamschool@gmail.com</a>
        </p>
        <p>
          Telegram:{" "}
          <a href="https://t.me/aamschool" target="_blank" rel="noopener noreferrer">
            https://t.me/aamschool
          </a>
        </p>
        <p>
          Website:{" "}
          <a href="https://aamschool.in" target="_blank" rel="noopener noreferrer">
            https://aamschool.in
          </a>
        </p>
      </section>

      <section className="page-policy-section">
        <h2>When To Contact Us</h2>
        <p>
          You can contact us for content corrections, link issues, general suggestions, partnership
          discussions, or questions related to information published on the site.
        </p>
        <p>
          For job updates, corrections, or business inquiries, email is the best contact method and
          we will try to respond as soon as reasonably possible.
        </p>
      </section>

      <section className="page-policy-section">
        <h2>Before Contacting Us</h2>
        <ul>
          <li>Please mention the page link or exam name if you are reporting an issue.</li>
          <li>Please verify official notices as well, especially for deadlines and eligibility.</li>
          <li>Please allow reasonable time for a response, especially during busy update periods.</li>
        </ul>
        <p>Thank you for visiting AAMSchool Naukari.</p>
      </section>
    </div>
  );
};

export default ContactUs;
